import {
  GuestJourneySettings,
  GuestJourneySettingsHistoryEntry,
  GuestJourneySettingsSnapshot,
} from '../guest-journey-reports.types';

/**
 * BE `GuestJourneySettingsDTO` — the per-client stage taxonomy. tier1 is the
 * lowest tier per axis; uppers are inclusive (tier2 spend = $20–$39 here).
 */
export const guestJourneySettingsFixture: GuestJourneySettings = {
  visitTier1Label: 'Explorer',
  visitTier2Label: 'Regular',
  visitTier3Label: 'Superfan',
  spendTier1Label: 'Value',
  spendTier2Label: 'Core',
  spendTier3Label: 'Indulgent',
  visitTier1Threshold: 3,
  visitTier2Threshold: 14,
  spendTier1Threshold: 19,
  spendTier2Threshold: 39,
};

/**
 * Display-ready settings snapshots (BE `GuestJourneySettingsSnapshotDTO`) — the
 * BE pre-formats each tier's name + range, so the diff drawer renders them
 * verbatim. tier1 → tier3 per axis.
 */
const originalSnapshot: GuestJourneySettingsSnapshot = {
  visitStages: [
    { name: 'Explorer', range: '1–5 visits' },
    { name: 'Regular', range: '6–20 visits' },
    { name: 'Superfan', range: '21+ visits' },
  ],
  spendStages: [
    { name: 'Value', range: '$0–$25' },
    { name: 'Core', range: '$26–$50' },
    { name: 'Indulgent', range: '$51+' },
  ],
};

/** Revision 2 — Regular's visit ceiling tightened and Core spend ceiling lowered. */
const revisedSnapshot: GuestJourneySettingsSnapshot = {
  visitStages: [
    { name: 'Explorer', range: '1–5 visits' },
    { name: 'Regular', range: '6–14 visits' },
    { name: 'Superfan', range: '15+ visits' },
  ],
  spendStages: [
    { name: 'Value', range: '$0–$25' },
    { name: 'Core', range: '$26–$39' },
    { name: 'Indulgent', range: '$40+' },
  ],
};

/** Revision 3 (current-ish) — a tier renamed and the Explorer ceiling lowered. */
const renamedSnapshot: GuestJourneySettingsSnapshot = {
  visitStages: [
    { name: 'Explorer', range: '1–3 visits' },
    { name: 'Frequent', range: '4–14 visits' },
    { name: 'Superfan', range: '15+ visits' },
  ],
  spendStages: revisedSnapshot.spendStages,
};

/**
 * BE `GuestJourneySettingsHistoryEntryDTO[]` — the "View Changes" audit trail,
 * newest first. Each entry carries the before/after snapshots that power the
 * "Threshold Changes" diff drawer. Timestamps are static so tests stay
 * deterministic.
 */
export const guestJourneySettingsHistoryFixture: GuestJourneySettingsHistoryEntry[] =
  [
    {
      id: 3,
      changedAt: '2025-09-02T23:55:07Z',
      changedBy: '5c70dd5a-a825-44f3-8eb7-a022d3cc250d',
      changedByName: 'William Powell',
      before: revisedSnapshot,
      after: renamedSnapshot,
    },
    {
      id: 2,
      changedAt: '2025-08-18T12:03:00Z',
      changedBy: 'a1b2c3d4-e5f6-47a8-9b0c-1d2e3f4a5b6c',
      changedByName: 'Tom Test',
      before: originalSnapshot,
      after: revisedSnapshot,
    },
    {
      id: 1,
      changedAt: '2025-07-29T02:00:17Z',
      changedBy: 'b2c3d4e5-f6a7-48b9-8c0d-2e3f4a5b6c7d',
      changedByName: 'Mod',
      before: originalSnapshot,
      after: originalSnapshot,
    },
  ];
